import React from 'react';
import { Link } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';
import useAuth from '../../hooks/useAuth';
import './Header.css'


const Header = () => {
    const { user, logOut } = useAuth();
    return (
        <div>
            <nav className="navbar navbar-expand-lg  navigationBackground">
                <div className="container-fluid">
                    <Link className="navbar-brand text-dark fw-bold ms-5" to="#">

                        TRAVEL</Link>
                    <button className="navbar-toggler bg-dark" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon text-light fw-bold">≡</span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup" >
                        <div className="navbar-nav navigationLink mx-auto">
                            <Link to="/">Home</Link>
                            <NavHashLink
                                smooth to="/home#service"
                                style={{ textDecoration: "none", }}
                            > Service</NavHashLink>
                            <NavHashLink
                                smooth to="/home#blog"
                                style={{ textDecoration: "none", }}
                            > Blog</NavHashLink>
                            <NavHashLink
                                smooth to="/home#contactus"
                                style={{ textDecoration: "none", }}
                            > Contact Us</NavHashLink>
                            <Link to="/about">About</Link>



                            {/* <Link to="/mybooking">My Booking</Link>
                            <Link to="/addnewservice">Add New Service</Link>
                            <Link to="/managebooking">Manage Booking</Link> */}

                            {user?.email ? (<>

                                <Link to="/addnewservice">Add New Service</Link>
                                <Link to="/mybooking">My Booking</Link>
                                <Link to="/managebooking">Manage Booking</Link>
                                <span style={{ color: "white", paddingTop: "10px" }}>{user ? user.displayName : user.email}</span>
                                <button className="btn btn-danger" onClick={logOut}>Logout</button>
                            </>
                            )
                                :
                                (<Link to="/login">Login</Link>)}

                        </div>

                        <div className='d-flex'>
                            <i class="fas fa-phone-square-alt fa-2x me-2" style={{ color: "#F4834A" }}></i>
                            <div className='d-flex flex-column'>
                                <span>Contact Now</span>
                                <span>+880-123-32</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav >

        </div >
    );
};

export default Header;